import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const tabClasses = tv({
  base: [
    "Tab__root",
    "flex",
    "items-center",
    "justify-center",
    "border-0",
    "px-3",
    "h-10",
    "text-base",
    "tracking-normal",
    "font-regular",
    "text-gray-600",
    "outline-none",
    "select-none",
    "before:inset-x-0",
    "before:inset-y-1",
    "before:rounded-lg",
    "before:-outline-offset-1",
    "before:outline-blue-800",
    "hover:text-gray-900",
    "focus-visible:relative",
    "focus-visible:before:absolute",
    "focus-visible:before:outline",
    "focus-visible:before:outline-2",
    "transition-all",
    "duration-300",
    "ease-in-out",
    "data-[selected]:text-primary-main",
  ],
  variants: {},
});
export type TabVariants = VariantProps<typeof tabClasses>;
